import tw from 'tailwind-styled-components'

export const TwMainContainer = tw.div`
  relative
  flex-1
  flex
  flex-col
  h-full
  min-h-0
`

export const TwSettingsSectionTitle = tw.div`
  mb-16
  text-primary
  text-sm-semibold
`

export const TwContentContainer = tw.div`
  mt-8
  ml-8
  flex
  flex-1
  flex-col
  min-h-0
`

export const TwHeaderRow = tw.div`
  flex
  gap-12
  px-12
  pb-4
`

export const TwHeaderCellLeft = tw.div`
  flex-[2]
  text-secondary
`

export const TwHeaderCellRight = tw.div`
  flex-1
  text-secondary
  pr-[65px]
`

export const TwFieldRow = tw.div`
  flex
  gap-12
  items-center
  group
  relative
  rounded-8
  px-12
  py-8
  transition-all
  hover:bg-background-hover
  first:pt-4
`

export const TwEmptyState = tw.div`
  text-secondary
  px-12
  pb-12
`
